import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-fiyatlari-neden-farkli/page.tsx");
